/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_CONFIGURATION_BY_TENANT = {
	isSciEnable: true,
	isWhatifEnable: false,
	isAnomalyEnable: true,
	isReportEnable: false
};
